module.exports = __webpack_public_path__ + "static/gap1-d570873075d1ff0070537b4966d5b51a.jpg";